import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject, signal } from '@angular/core';
import type { ApiTypes } from '@hyundai/ng-common-lib';
import { CacheService, CampaignFeature, DealerApiService, DealerFeature } from '@hyundai/ng-common-lib';
import { M040C050CardComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-campaign-overview-page',
    standalone: true,
    templateUrl: './campaign-overview-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, M040C050CardComponent],
})
export default class CampaignOverviewPageComponent {
    protected readonly store = inject(Store);
    protected readonly api = inject(DealerApiService);
    protected readonly c = inject(CacheService).setCacheSettings({
        maxAge: 60,
        staleWhileRevalidate: 300,
        staleIfError: 600,
    });

    protected dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    protected dealerLocationHeadline = this.store.selectSignal(DealerFeature.state.selectDealerLocationHeadline);
    protected campaigns = this.store.selectSignal(CampaignFeature.state.selectLoadedCampaignsOverview);
    filter = signal<ApiTypes.CampaignsOverview['categories'][0] | 'all'>('all');

    filterredCampaigns = computed(() => {
        const campaignList = this.campaigns().campaignsRegular;
        const filter = this.filter();
        if (!campaignList) {
            return [];
        }
        if (filter === 'all') {
            return campaignList;
        }
        return campaignList.filter((campaign) => campaign.badge === filter);
    });
}
